import React, { useState } from 'react'

import { GridRowParams, GridRowSelectionModel } from '@mui/x-data-grid'
import BulkDeleteButton from '../../components/buttons/BulkButtons/BulkDeleteButton'
import { useNavigate } from 'react-router-dom'
import { EdifyDataGridV2 } from '../../components/datagrid/EdifyDataGridV2'
import { submitter_columns } from '../../components/datagrid/gridData/postSubmissions'
import { ISubmitter } from '../../../domain/interfaces/ISubmission'
import { EdifyButton } from '../../components/buttons'
import SubmissionModal from './SubmissionModal'
import { ROUTE_SUBMISSIONS } from '../corrective-actions/CorrectiveActionsPage'

interface IPostSubmissionDataGridProps {
  rows: ISubmitter[]
  title: string
  formId: string
  parentFormId: string
  checkboxSelection?: boolean
  parentSubmissionId: string
  userId: string
}

const PostSubmissionDataGrid: React.FC<IPostSubmissionDataGridProps> = ({
  rows,
  title,
  formId,
  parentFormId,
  parentSubmissionId,
  checkboxSelection = false,
  userId,
}) => {
  const navigate = useNavigate()
  const [selectionModel, setSelectionModel] = React.useState<GridRowSelectionModel>([])
  const [open, setOpen] = useState<boolean>(false)

  // Edit/View post submission
  const handleRowClicked = (params: GridRowParams) => {
    // clear parent submission data
    localStorage.removeItem('initialSubmission')
    navigate(`/forms${ROUTE_SUBMISSIONS}/${formId}/submission/${params.row.submissionId}`, {
      state: { parentFormId: parentFormId, parentSubmissionId: parentSubmissionId },
    })
  }

  const navigateToCreateForm = () => {
    navigate(
      `/forms${ROUTE_SUBMISSIONS}/${formId}/submission/new?parentSubmissionId=${parentSubmissionId}&submitterId=${userId}`,
      {
        state: { parentFormId: parentFormId, parentSubmissionId: parentSubmissionId },
      },
    )
  }

  const renderHeaderButtons = () => {
    // const noSelections = selectionModel.length === 0
    // return (
    //   <BulkDeleteButton noSelections={noSelections} onClick={removeClicked} />
    // )
    return <EdifyButton noBackground title={`New ${title}`} onClick={navigateToCreateForm} />
  }

  return (
    <>
      <EdifyDataGridV2
        data-testid='PostSubmissionDataGrid'
        paginationMode='client'
        clientSideProcessing={true}
        title={title}
        noRowsText={'No submissions found.'}
        renderHeaderButtons={renderHeaderButtons()}
        columns={submitter_columns}
        rows={rows}
        rowSelectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
        handleRowClicked={handleRowClicked}
        rowCount={rows.length || 0}
        // sortClickedHandler={vm.sortClickedHandler} //TODO
        // checkboxSelection={checkboxSelection}
        checkboxSelection={false}
        initSort={[{ field: 'createdAt', sort: 'asc' }]}
      />
      {/* {open && (
        //68a29f37-6656-4534-9712-97e64ad3482e
        <SubmissionModal
          initMode={getInitMode()}
          canSign={true}
          open={open}
          handleClose={handleClose}
          orgId={orgId}
          childForm={form}
          subId={activeSubId}
          // subId={undefined}
          submitter={activeSignee}
          parentSubId={parentSubmission.id}
          currentUserId={userId}
          isAnon={false}
          formReadOnly={formReadOnly}
        />
      )} */}
    </>
  )
}

export default PostSubmissionDataGrid
